<template>
    <page>
        <module enable-flex>
            <div class="account flex">
                <div class="item flex-grow item-blue">
                    <div class="info">
                        <div class="title-row flex-start-center">
                            <span class="title">IMEI查询积分余额：</span>
                            <span class="amount">{{ account.imie_points || 0 }}</span>
                        </div>
                    </div>
                    <div class="actions">
                        <button class="btn btn-orange"
                                v-if="auth('b_imei_points_record_recharge')"
                                @click="globalDialog('pointsRecharge', {props: {account_type:5}},handle)">充值</button>
                        <c-link style="color:white;"
                                v-if="auth('b_imei_points_record_recharge')"
                                @click="rechargeApplyList()">
                            充值记录
                        </c-link>
                    </div>
                </div>
            </div>
            <view-list ref="view" class="flex-grow" hide-view :work-type="workType" :view-config="saasInfo.viewmanage">
                <template #search>
                    <m-search ref="search" :extend-data="defaultSearchData">
                        <m-search-item label="记录单号">
                            <c-input name="record_number"></c-input>
                        </m-search-item>
                        <m-search-item label="创建时间">
                            <c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
                        </m-search-item>
                    </m-search>
                </template>

                <template #operate>
                    <c-button v-if="auth('b_imei_points_record_export')"
                                prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出
                    </c-button>
                </template>

                <!--账户类型-->
                <template #account_type="{data}">
                    <c-state  async dict="ACCOUNT_TYPE" :value="data.account_type"></c-state>
                </template>
                <!--收支类型-->
                <template #income_expenses="{data}">
                    <c-state  async dict="INCOME_EXPENSES" :value="data.income_expenses"></c-state>
                </template>
                <!--收支状态-->
                <template #trans_state="{data}">
                    <c-state  async dict="TRANS_STATE" :value="data.trans_state"></c-state>
                </template>
                <!--资金-->
                <template #money="{data}">
                    <span v-if="data.income_expenses == 1" style="color: green">+{{data.money}}</span>
                    <span v-if="data.income_expenses == 2" style="color: red">{{data.money}}</span>
                </template>
                <!--余额-->
                <template #surplus_money="{data}">
                    <span v-if="data.surplus_money">
                        {{data.surplus_money}}
                    </span>
                    <span v-else>-</span>
                </template>
            </view-list>
        </module>
    </page>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: 'm_points_record',
    data() {
        return {
            workType: 115,
            defaultSearchData: {
                user_type: 1,     //默认查询主账号数据
                trans_states:[1,3]  //不展示【2：处理中】的记录
            },
            account: {}
        }
    },
    computed: {
        // 获取dictName选项数据
        ...mapState(['saasInfo'])
    },

    mounted() {
        this.loadAccount();
    },
    methods: {
        /**
         * 加载账户余额信息
         */
        loadAccount() {
            this.request({
                url: '/sys_saas/account/info',
                data: {},
                loading: false,  // 是否显示loading，
                success: data => {
                    this.account = data;
                }
            });
        },
        /*********充值或提现申请完成后回调****************/
        handle() {
            //1、重新加载余额
            this.loadAccount();
            //2、加载数据列表
            this.$refs.view.update();
        },
        /*********查询充值记录****************/
        rechargeApplyList() {
            //打款弹窗
            this.globalDialog('rechargeApplyList', {props: {withdraw_account_type:5}});
            //2、重新加载余额
            this.loadAccount();
        }
    }
}
</script>

<style lang="stylus" scoped>
.account {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    padding: 12px 16px 2px;

    .item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        max-width: 478px;
        padding: 12px 20px 14px;
        border-radius: 8px;
        color: #fff;

        &.item-blue {
            background: linear-gradient(90deg, #2563eb, #3b82f6);
        }

        &.item-orange {
            background: linear-gradient(90deg, #f97316, #fb923c);
        }

        .info {
            .title-row {
                display: flex;
                line-height: 32px;

                .title {
                    font-size: 13px;
                    opacity: 0.95;
                }

                .amount {
                    font-size: 24px;
                    font-weight: bold;
                }
            }

            .summary-row {
                gap: .5em;
                margin-top: 4px;
                font-size: 12px;
                opacity: 0.8;
            }
        }

        .actions {
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            gap: 8px;

            .btn-group {
                display: flex;
                gap: 10px;
            }

            .btn {
                padding: 6px 18px;
                border: none;
                border-radius: 16px;
                font-size: 13px;
                cursor: pointer;
                transition: opacity 0.2s;

                &:disabled {
                    opacity: 0.5;
                    cursor: not-allowed;
                }

                &.btn-orange {
                    background: #ff8c00;
                    color: #fff;

                    &:not(:disabled):hover {
                        background: #ffa033;
                    }
                }

                &.btn-white {
                    background: #fff;
                    color: #333;

                    &:not(:disabled):hover {
                        background: #f0f0f0;
                    }
                }
            }

            .recharge {
                font-size: 13px;
                color: #fff;
                opacity: 0.9;
                cursor: pointer;
                text-decoration: underline;

                &:hover {
                    opacity: 1;
                }
            }
        }
    }
}
</style>